// extracted by mini-css-extract-plugin
export default {"container":"OrganizationResourceSelection__container___gP74E","feedContainer":"OrganizationResourceSelection__feedContainer___lrEdQ"};